import React from 'react';
import compose from '@hypnosphi/recompose/compose';
import { withStyles } from '@mui/styles';
import { InputLabel } from '@mui/material';
import TextField from 'apollo-react/components/TextField';

const styles = theme => ({
  // trick to show the toolback only when hovering 
  counter: {
    marginTop: 0
    ,
    '&:hover .hoverover': {
      opacity: 1,
      pointerEvents: 'inherit',
    }},
  msg:
  {
    marginTop: '12px',
    display: 'inline-block'
  }
  });

export const Counter = (props) => {
  const {onChange, msgSuffix, msgPrefix, inputLabel, value, classes, maxValue, minValue, disabled} = props; 
   
  return (
    <>
      <InputLabel>{inputLabel}</InputLabel>
      <div>
        <span className={classes.msg}>{msgPrefix}&nbsp;</span>
        <TextField className={classes.counter} type='number' value={value} disabled={disabled} onChange={onChange} inputProps={{min: minValue, step: "1", max: maxValue}} />
        <span className={classes.msg}>&nbsp;{msgSuffix}</span>
      </div>
    </>
  );
};

export default compose(
  withStyles(styles)
)(Counter);
